// Free email providers. Keep in sync with server/src/common/emailDomains/publicEmailDomains.ts.
export const publicEmailDomains = [
  '126.com',
  '163.com',
  'abv.bg',
  'alice.it',
  'aliyun.com',
  'aol.ca',
  'aol.co.nz',
  'aol.co.uk',
  'aol.com',
  'aol.com.au',
  'aol.com.br',
  'aol.com.mx',
  'aol.de',
  'aol.fr',
  'att.net',
  'bellsouth.net',
  'bigmir.net',
  'bigpond.com',
  'bigpond.net.au',
  'bk.ru',
  'bluewin.ch',
  'blueyonder.co.uk',
  'bol.com.br',
  'btinternet.com',
  'centrum.cz',
  'charter.net',
  'comcast.net',
  'consultant.com',
  'cox.net',
  'daum.net',
  'dir.bg',
  'disroot.org',
  'earthlink.net',
  'email.com',
  'fastmail.com',
  'foxmail.com',
  'free.fr',
  'freenet.de',
  'frontier.com',
  'gmail.co.uk',
  'gmail.com',
  'gmx.at',
  'gmx.au',
  'gmx.be',
  'gmx.ca',
  'gmx.ch',
  'gmx.cn',
  'gmx.co.uk',
  'gmx.co.za',
  'gmx.com',
  'gmx.com.br',
  'gmx.com.mx',
  'gmx.de',
  'gmx.eg',
  'gmx.es',
  'gmx.fr',
  'gmx.hk',
  'gmx.in',
  'gmx.it',
  'gmx.jp',
  'gmx.net',
  'gmx.ng',
  'gmx.nl',
  'gmx.nz',
  'gmx.ph',
  'gmx.pk',
  'gmx.pt',
  'gmx.sa',
  'gmx.sg',
  'gmx.th',
  'gmx.tw',
  'gmx.us',
  'gmx.vn',
  'googlemail.com',
  'hanmail.net',
  'hey.com',
  'home.nl',
  'hotmail.be',
  'hotmail.ca',
  'hotmail.cl',
  'hotmail.co.jp',
  'hotmail.co.uk',
  'hotmail.co.za',
  'hotmail.com',
  'hotmail.com.ar',
  'hotmail.com.au',
  'hotmail.com.br',
  'hotmail.com.co',
  'hotmail.com.mx',
  'hotmail.com.tw',
  'hotmail.com.vn',
  'hotmail.de',
  'hotmail.dk',
  'hotmail.es',
  'hotmail.fi',
  'hotmail.fr',
  'hotmail.gr',
  'hotmail.it',
  'hotmail.nl',
  'hotmail.no',
  'hotmail.pt',
  'hotmail.se',
  'hushmail.com',
  'i.ua',
  'icloud.com',
  'ig.com.br',
  'inbox.com',
  'inbox.ru',
  'interia.pl',
  'internet.ru',
  'juno.com',
  'kpnmail.nl',
  'laposte.net',
  'libero.it',
  'list.ru',
  'live.be',
  'live.ca',
  'live.cn',
  'live.co.uk',
  'live.co.za',
  'live.com',
  'live.com.ar',
  'live.com.au',
  'live.com.br',
  'live.com.co',
  'live.com.eg',
  'live.com.hk',
  'live.com.mx',
  'live.com.my',
  'live.com.ng',
  'live.com.ph',
  'live.com.pk',
  'live.com.sa',
  'live.com.sg',
  'live.com.tr',
  'live.com.tw',
  'live.com.vn',
  'live.de',
  'live.dk',
  'live.fi',
  'live.fr',
  'live.gr',
  'live.in',
  'live.jp',
  'live.nl',
  'live.no',
  'live.pt',
  'live.se',
  'lycos.com',
  'mac.com',
  'mail.bg',
  'mail.com',
  'mail.kz',
  'mail.ru',
  'mailbox.org',
  'mailfence.com',
  'me.com',
  'meta.ua',
  'msn.com',
  'myself.com',
  'naver.com',
  'neuf.fr',
  'ntlworld.com',
  'o2.pl',
  'onet.pl',
  'online.no',
  'optonline.net',
  'optusnet.com.au',
  'orange.fr',
  'outlook.com',
  'outlook.com.br',
  'outlook.de',
  'outlook.es',
  'outlook.fr',
  'outlook.in',
  'outlook.it',
  'outlook.jp',
  'planet.nl',
  'pm.me',
  'poczta.fm',
  'poczta.onet.pl',
  'post.com',
  'posteo.de',
  'posteo.net',
  'privaterelay.appleid.com',
  'proton.me',
  'protonmail.ch',
  'protonmail.com',
  'qq.com',
  'rambler.ru',
  'rediffmail.com',
  'rocketmail.com',
  'rogers.com',
  'runbox.com',
  'sbcglobal.net',
  'seznam.cz',
  'sfr.fr',
  'shaw.ca',
  'sina.cn',
  'sina.com',
  'sky.com',
  'skynet.be',
  'sohu.com',
  'sympatico.ca',
  't-online.de',
  'talk21.com',
  'talktalk.net',
  'telenet.be',
  'telia.com',
  'terra.com.br',
  'tin.it',
  'tiscali.it',
  'tuta.com',
  'tuta.io',
  'tutamail.com',
  'tutanota.com',
  'tutanota.de',
  'ukr.net',
  'uol.com.br',
  'usa.com',
  'verizon.net',
  'virgilio.it',
  'virgin.net',
  'virginmedia.com',
  'volny.cz',
  'wanadoo.fr',
  'web.de',
  'webmail.co.za',
  'windowslive.com',
  'windstream.net',
  'wp.pl',
  'xs4all.nl',
  'xtra.co.nz',
  'ya.ru',
  'yahoo.ca',
  'yahoo.co.id',
  'yahoo.co.in',
  'yahoo.co.jp',
  'yahoo.co.kr',
  'yahoo.co.nz',
  'yahoo.co.th',
  'yahoo.co.uk',
  'yahoo.co.za',
  'yahoo.com',
  'yahoo.com.ar',
  'yahoo.com.au',
  'yahoo.com.br',
  'yahoo.com.cn',
  'yahoo.com.eg',
  'yahoo.com.hk',
  'yahoo.com.mx',
  'yahoo.com.my',
  'yahoo.com.ng',
  'yahoo.com.ph',
  'yahoo.com.pk',
  'yahoo.com.sa',
  'yahoo.com.sg',
  'yahoo.com.tr',
  'yahoo.com.tw',
  'yahoo.com.vn',
  'yahoo.de',
  'yahoo.es',
  'yahoo.fr',
  'yahoo.it',
  'yandex.by',
  'yandex.com',
  'yandex.kz',
  'yandex.ru',
  'yandex.ua',
  'yeah.net',
  'ymail.com',
  'ziggo.nl',
  'zoho.com',
  'zoho.com.au',
  'zoho.eu',
  'zoho.in',
  'zohomail.com',
  'zohomail.eu',
  'zoznam.sk',
];

// The most common disposable providers, for instant feedback in forms. The server checks the
// full list (server/src/common/emailDomains/disposableEmailDomains.ts) and has the final say.
export const temporaryEmailDomains = [
  '10minutemail.co.uk',
  '10minutemail.com',
  '10minutemail.net',
  '1secmail.com',
  '1secmail.net',
  '1secmail.org',
  '20minutemail.com',
  'anonbox.net',
  'boximail.com',
  'byom.de',
  'crazymailing.com',
  'deadaddress.com',
  'discard.email',
  'discardmail.com',
  'dispostable.com',
  'dropmail.me',
  'e4ward.com',
  'einrot.com',
  'emailfake.com',
  'emailondeck.com',
  'emlhub.com',
  'emlpro.com',
  'emltmp.com',
  'eyepaste.com',
  'fakeinbox.com',
  'fakemail.net',
  'gawab.com',
  'getairmail.com',
  'getnada.com',
  'grr.la',
  'guerrillamail.biz',
  'guerrillamail.com',
  'guerrillamail.de',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamailblock.com',
  'harakirimail.com',
  'inboxkitten.com',
  'incognitomail.org',
  'jetable.fr.nf',
  'linshiyouxiang.net',
  'mail.tm',
  'mailcatch.com',
  'maildrop.cc',
  'mailexpire.com',
  'mailforspam.com',
  'mailinator.com',
  'mailinator.net',
  'mailinator2.com',
  'mailnesia.com',
  'mailnull.com',
  'mailpoof.com',
  'mailsac.com',
  'mintemail.com',
  'minuteinbox.com',
  'moakt.cc',
  'moakt.com',
  'mohmal.com',
  'mt2015.com',
  'mvrht.net',
  'mytemp.email',
  'nada.email',
  'pokemail.net',
  'sharklasers.com',
  'spam4.me',
  'spambox.us',
  'spamex.com',
  'spoofmail.de',
  'temp-mail.org',
  'tempail.com',
  'tempinbox.com',
  'tempmail.plus',
  'tempmailo.com',
  'temporary-mail.net',
  'tempr.email',
  'throwawaymail.com',
  'tmail.ws',
  'tmpeml.com',
  'tmpmail.net',
  'tmpmail.org',
  'trashmail.com',
  'trashmail.de',
  'trashmail.me',
  'trashmail.net',
  'trbvm.com',
  'wegwerfmail.de',
  'wegwerfmail.net',
  'yopmail.com',
  'yopmail.fr',
  'yopmail.net',
];
